<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .select-cell {
    min-width: utils.in_rem(200px);
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
  }
</style>

<script>
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";

  export let selectedOption;
  export let onSelect;
  export let disabled = false;

  let closeDropdown;

  const updateOptions = [
    { value: "always", label: "Always update" },
    { value: "ifBlank", label: "Only update if blank" },
  ];
</script>

<div class="select-cell">
  <Dropdown
    style="width:180px"
    kind="input-field"
    bind:close={closeDropdown}
    {disabled}
  >
    <span slot="button">
      {updateOptions.find((opt) => opt.value === selectedOption)?.label ||
        "Select option"}
    </span>
    {#each updateOptions as option}
      <ListItem
        selected={selectedOption === option.value}
        onclick={() => {
          onSelect(option.value);
          closeDropdown();
        }}
      >
        {option.label}
      </ListItem>
    {/each}
  </Dropdown>
</div>
